import { z } from 'zod';
/**
 * The document header's record navigation (S4 — INV-H2/H9, IT-N1/N7), shared
 * by every document kind that has a number series: sales invoices, quotations,
 * sales orders, purchase bills, purchase orders, goods receipts, and items by
 * code.
 *
 * Two reads, both scoped by RLS like every other route on the same router:
 *
 *  - `neighbours` — the ids on either side of THIS record in number order, so
 *    the editor's ‹‹ ›› buttons step through the series the way the list is
 *    sorted. Null at either end.
 *  - `lookup` — one record by its PRINTED number (`INV-0042`) or the bare
 *    number (`42`), for the "Go to no." box. A miss is a 404: the screen
 *    renders its own sentence for that, so the body carries no new wording.
 */
export const DocumentNeighboursSchema = z
    .object({
    prevId: z.uuid().nullable(),
    nextId: z.uuid().nullable(),
})
    .strict();
export const DocumentLookupQuerySchema = z
    .object({
    /** The printed code or the bare number; matched ignoring case and spaces. */
    code: z.string().trim().min(1).max(60),
})
    .strict();
export const DocumentLookupResponseSchema = z
    .object({
    id: z.uuid(),
    code: z.string(),
})
    .strict();
//# sourceMappingURL=document-navigation.js.map